// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `bin/just codegen-experiment-function --experiment web-frontend-overlay-stacking --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeStringFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useWebFrontendOverlayStackingVariation = makeStringFlagValueHook('web-frontend-overlay-stacking');
//# sourceMappingURL=useWebFrontendOverlayStackingVariation.js.map